import { GiTaskCategoryType } from '@gi/enums/gi-task-category-type.enum';

export interface GiTaskCategoryJson {
  id: number;
  wording: string;
  type: GiTaskCategoryType;
  company_mandatory: boolean;
}

export class GiTaskCategory {
  constructor(
    public id?: number,
    public wording?: string,
    public type?: GiTaskCategoryType,
    public companyMandatory?: boolean
  ) {}

  static fromJson(json: GiTaskCategoryJson): GiTaskCategory {
    return new GiTaskCategory(json.id, json.wording, json.type, json.company_mandatory);
  }

  static toJson(giTaskCategory: GiTaskCategory): GiTaskCategoryJson {
    return {
      id: giTaskCategory.id ?? undefined,
      wording: giTaskCategory.wording,
      type: giTaskCategory.type,
      company_mandatory: giTaskCategory.companyMandatory
    };
  }
}
